/**
 * ContractStatusBadge Component
 *
 * Displays contract status with appropriate color coding
 */
import { statusLabels, statusColors, type ContractStatus } from '../../hooks/useContracts';

interface ContractStatusBadgeProps {
  status: ContractStatus;
  size?: 'sm' | 'md';
  className?: string;
}

export function ContractStatusBadge({ status, size = 'md', className = '' }: ContractStatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2 py-0.5 text-xs',
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${sizeClasses[size]} ${statusColors[status]} ${className}`}
    >
      {statusLabels[status]}
    </span>
  );
}
